@keyframes shimmer {
    0% {
        background-position: -200% 0;
    }

    100% {
        background-position: 200% 0;
    }
}

.skeletonContainer {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    overflow: hidden;
    padding: 0.5rem;
}

.skeletonImage {
    fill: var(--static-text-weak);
}

@media (prefers-color-scheme: dark) {
    :root {
        --interactive-fill-skeleton-background: rgb(255, 255, 255, 0.18);
        --interactive-fill-skeleton-shimmer: rgb(255, 255, 255, 0.15);
    }

    .shimmering {
        background-image: linear-gradient(90deg,
                var(--interactive-fill-skeleton-background) 0px,
                var(--interactive-fill-skeleton-shimmer) 40px,
                var(--interactive-fill-skeleton-background) 80px);
        background-size: 200% 100%;
        animation: shimmer 1.25s infinite linear;
    }
}

@media (prefers-color-scheme: light) {
    :root {
        --interactive-fill-skeleton-background: rgb(0, 0, 0, 0.06);
        --interactive-fill-skeleton-shimmer: rgb(0, 0, 0, 0.15);
    }

    .shimmering {
        background-image: linear-gradient(90deg,
                var(--interactive-fill-skeleton-background) 0px,
                var(--interactive-fill-skeleton-shimmer) 40px,
                var(--interactive-fill-skeleton-background) 80px);
        background-size: 200% 100%;
        animation: shimmer 1.25s infinite linear;
    }
}

@keyframes shimmer {
    0% {
        background-position: 200% 0;
    }

    100% {
        background-position: -200% 0;
    }
}